import React from 'react';
import { StyledButton } from './buttons.styles';
import Spinner from '../loaders/spinner';

export const Button = ({ children, ...props }) => {
	const { loading } = props;

	return (
		<StyledButton {...props}>
			{
				!loading && children
			}
			{
				loading && (
					<>
						<span>{children}</span>
						<Spinner size="sm" marginLeft="1rem" />
					</>
				)
			}
		</StyledButton>
	);
};
